import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="see-more"
export default class extends Controller {
  static targets = ['short', 'full', 'text', 'button']

  connect() {
    if (this.hasTextTarget) this.#fitToClamp()
  }

  expand(event) {
    event.preventDefault()
    this.shortTarget.classList.add('hidden')
    this.fullTarget.classList.remove('hidden')
  }

  // Le line-clamp-N de la vue fige la hauteur dès le premier rendu (pas de saut) ;
  // la coupe se mesure sous cette contrainte, puis le clamp saute.
  #fitToClamp() {
    const paragraph = this.shortTarget
    const fits = () => paragraph.scrollHeight <= paragraph.clientHeight + 1

    if (fits()) {
      this.buttonTarget.classList.add('hidden')
      this.#unclamp(paragraph)
      return
    }

    // Each word keeps the whitespace that follows it: line breaks survive the cut.
    const words = this.textTarget.textContent.trim().match(/\S+\s*/g) ?? []
    const cut = (count) => words.slice(0, count).join('').trimEnd() + '…'
    let low = 0
    let high = words.length
    while (low < high) {
      const mid = Math.ceil((low + high) / 2)
      this.textTarget.textContent = cut(mid)
      fits() ? (low = mid) : (high = mid - 1)
    }
    this.textTarget.textContent = cut(low)
    this.#unclamp(paragraph)
  }

  #unclamp(paragraph) {
    paragraph.classList.remove(...[...paragraph.classList].filter((name) => name.startsWith('line-clamp-')))
  }
}
